import { getRequest } from '../api-handler';
import { MixtureTypeDetailDto } from './mixturetype';

export const MixtureTypeApi = {
  getById: (id: number) =>
    getRequest<MixtureTypeDetailDto>(`/mixturetypes/${id}`)
};
